export const DASHBOARD_SETTINGS='DASHBOARD_SETTINGS';

export const RAW_PROGRAMS='RAW_PROGRAMS';
export const RAW_PROGRAMS_UPDATE='RAW_PROGRAMS_UPDATE';

export const SUCCEEDED='SUCCEEDED';
export const REQUEST='REQUEST';
export const DELETETHIS='DELETETHIS';
export const INTERNAL_UPDATE='INTERNAL_UPDATE';

export const LOGIN_REQUEST ='LOGIN';
export const LOGIN_SUCCEEDED ='LOGIN_SUCCEEDED';
